import ButtonLink from 'dyl-components/atoms/ButtonLink';
import DateTimeUtils from 'dyl-components/utils/DateTimeUtils';
import React, { useState } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { PhoneUtil } from 'utils';
import VoicemailPlayback from '../VoicemailPlayback';

const DIRECTION_ICONS = {
    inbound: "fa-solid fa-phone-arrow-down-left",
    outbound: "fa-solid fa-phone-arrow-up-right",
    internal: "fa-solid fa-people-pants-simple"
}

const PERSON_TYPE_ICON = {
    person: "fa-solid fa-user",
    household: "fa-solid fa-house-chimney",
    business: "fa-solid fa-buildings",
}

const OfficeViewRecentItem = ({ 
    recent,
    onRecentCallClick,
    setViewCallMode,
    onMarkVoicemailAsListened,
    onClickToDialList,
    isPhoneSystemSupported,
    logActivityForm
}) => {
    const [isVoicemailPlaybackOpen, setIsVoicemailPlaybackOpen] = useState(false);
    const [isCallActivityFormOpen, setIsCallActivityFormOpen] = useState(false);
    const isPrimaryPhone = (recent?.contacts?.length && recent?.contacts?.[0]?.primary);
    return (
        <div 
            key={recent.call_uuid} 
            onClick={() => {
                if (!isVoicemailPlaybackOpen) {
                    onRecentCallClick(recent.call_uuid, recent.direction === "internal");
                    setViewCallMode(true);
                }
            }} 
            className={`OfficeViewRecents__element OfficeViewRecents__element--hover`}
        >
            <div style={{flex: 1, display: 'flex', gap: 10}}>
                <Popup
                    trigger={ <div className={`RecentCalls__missedCallBorder ${!recent.unreturned ? "RecentCalls__missedCallBorder--invisible" : ""}`} /> }
                    content={"Call Not Returned"}
                    inverted
                    disabled={recent.not_returned}
                />
                <div>
                    <div><b>{DateTimeUtils.formatEpoch(recent.start_ts, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                    <div>{DateTimeUtils.formatEpoch(recent.start_ts, DateTimeUtils.TIME_FORMAT)}</div>
                </div>
            </div>
            <div style={{display: 'flex', alignItems: 'center', gap: 10, flex: 3}}>
                <Icon className={`${DIRECTION_ICONS[recent.direction] || ""}`} />
                <div>
                    <div>
                        {recent?.contacts?.[0] && recent?.contacts?.[0]?.name && (
                            <Icon className={PERSON_TYPE_ICON[recent.contacts?.[0]?.type || ""]} size={"small"} style={{marginRight: 7}} />
                        )}
                        <ButtonLink style={{paddingLeft: 0}}>{recent.contacts?.[0]?.name || recent.contacts?.[0]?.contact_name || recent.users?.[0]?.name || recent.destination?.label || "Unknown"}</ButtonLink>
                    </div>
                    <span className={`RecentCalls__resultColor${!!recent.connected_ts ? "--green" : "--red"}`}>{recent.system_result}</span>
                </div>
            </div>
            <div style={{display: 'flex', alignItems: 'center', flex: 1}}>
                <div>
                    <span>{recent.contacts.length > 0 ? PhoneUtil.formatPhoneNumber(recent.contacts?.[0]?.phone) : recent.users?.[0]?.extension ? `Ext. ${recent.users?.[0]?.extension}` : recent.destination?.label}</span>
                    {isPrimaryPhone ? <Icon name='star' color='blue' style={{ marginLeft: 4 }} /> : ""}
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 7, flex: 2}}>
                {isPhoneSystemSupported ?
                    <ButtonLink onClick={(event) => {
                        event.stopPropagation();
                        const payload = recent.contacts.length > 0 ? {
                            account_id: recent.contacts?.[0]?.account_id,
                            contact_id: recent.contacts?.[0]?.contact_id,
                            destination: recent.contacts?.[0]?.phone
                        } : {
                            destination: recent.users?.[0]?.extension,
                            to_user_id: recent.users?.[0]?.user_id
                        }
                        onClickToDialList(payload)
                    }}>
                        <Icon className='fa-solid fa-phone' size={"large"} />
                    </ButtonLink>
                    : <Popup
                            className="AddForm"
                            trigger={
                                <ButtonLink>
                                    <Icon
                                        className="fa-solid fa-phone OfficeView__icons"
                                        size={"large"}
                                        primary
                                    />
                                </ButtonLink>
                            }
                            content={() =>
                                logActivityForm?.(
                                    {
                                        id: recent?.contacts?.[0]?.contact_id || recent.contacts?.[0]?.account_id,
                                    },
                                    false,
                                    recent?.contacts?.[0]?.contact_id ? true : false,
                                    () => setIsCallActivityFormOpen(false),
                                    true
                                )
                            }
                            closeOnDocumentClick={false}
                            open={isCallActivityFormOpen}
                            onClose={() => setIsCallActivityFormOpen(false)}
                            onOpen={() => setIsCallActivityFormOpen(true)}
                            on="click"
                            position="bottom left"
                            pinned
                            basic
                            wide
                        />}
                <ButtonLink onClick={(event) => event.stopPropagation()} disabled>
                    <Icon className='fa-solid fa-split' size={"large"} />
                </ButtonLink>
                <Popup
                    style={{minWidth:400}}
                    trigger={
                        <Icon className={`fa-solid fa-voicemail ${!recent.voicemail ? `RecentCalls__missedCallBorder--invisible` : ""}`} size="large" color="primary" />
                    }
                    on="click"
                    content={
                        <VoicemailPlayback
                            onClose={(event) => {
                                event.stopPropagation();
                                setIsVoicemailPlaybackOpen(false)
                            }}
                            className={`audio-playback-${recent.call_uuid}`}
                            link={recent.voicemail}
                            fileName="Voicemail"
                            isVoicemail
                            onMarkAsListened={() => onMarkVoicemailAsListened(recent?.call_uuid)}
                        />
                    }
                    position="bottom center"
                    open={isVoicemailPlaybackOpen}
                    onOpen={(event) => {
                        event.stopPropagation();
                        setIsVoicemailPlaybackOpen(true);
                    }}
                />
            </div>
        </div>
    )
}

export default OfficeViewRecentItem;